import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { AuthModule } from '~/auth/auth.module';
import { ComponentModule } from '~/component/component.module';
import { CoreModule } from '~/core/core.module';
import { OrganizerSharedModule } from '~/organizer/shared/shared.module';

import { PayoutInvoicesComponent } from './components/pages/payout-invoices/payout-invoices.component';
import { PayoutInvoicesRoutingModule } from './payout-invoices-routing.module';
import { FullCalendarModule } from '@fullcalendar/angular';

@NgModule({
  declarations: [PayoutInvoicesComponent],
  imports: [
    ReactiveFormsModule,
    FormsModule,
    AuthModule,
    CommonModule,
    CoreModule,
    PayoutInvoicesRoutingModule,
    ComponentModule,
    OrganizerSharedModule,
    FullCalendarModule,
  ],
})
export class PayoutInvoicesModule {}
